import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
import AnimationLayout from '@/components/animation/AnimationLayout';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();
  const transactionCode = localStorage.getItem('transactionCode');

  // Redirect to dashboard if already authenticated
  if (isAuthenticated && transactionCode) {
    return <Navigate to="/transaction-code" replace />;
  } else if (isAuthenticated && !transactionCode) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <div
        className="min-h-screen text-text flex flex-col p-5 overflow-hidden bg-page"
        style={{
          backgroundImage:
            'radial-gradient(circle at 15% 20%, rgb(var(--gold) / 0.12) 0%, transparent 40%), radial-gradient(circle at 85% 80%, rgb(26 61 166 / 0.12) 0%, transparent 45%)',
        }}
      >
        {/* <AnimationLayout /> */}
        {/* Rotated background image */}
        {/* <div
          className="absolute inset-0 z-0  origin-center"

        /> */}

        {/* Logo */}
        {/* <img src={`${imagekit}/login/logo.png`} alt="" className="w-40 relative z-10" /> */}

        {/* Centered Section */}
        <AnimationLayout className="flex-grow">
          <div className="flex-grow flex-center relative z-10">
            <div className="relative max-w-[560px] w-full mx-auto flex-center flex-col">
              {/* <img src={`${imagekit}/login/logo.png`} alt="" className="w-80 relative z-10 mb-10" /> */}
              <Outlet />
            </div>
          </div>
        </AnimationLayout>
      </div>
    </>
  );
}
